import { render, staticRenderFns } from "./UIResultXSMNListNumber.vue?vue&type=template&id=2d6b4753&scoped=true&"
import script from "./UIResultXSMNListNumber.vue?vue&type=script&lang=js&"
export * from "./UIResultXSMNListNumber.vue?vue&type=script&lang=js&"
import style0 from "./UIResultXSMNListNumber.vue?vue&type=style&index=0&id=2d6b4753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b4753",
  null
  
)

export default component.exports